import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import Table from 'rc-table';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { createStructuredSelector } from 'reselect';
import { BaseComponent } from '../../../components/BaseComponent';
import { property } from 'lodash/util';

import { selectAddressTypes } from '../../Address/selectors';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import { CircleTimes } from '../../../components/Icon';

const Container = styled.div`
  width: 100%;
  background: white;
`;

const CustomTable = styled(Table)`
  width: 100%;
  display: flex;
  font-size: 12px;

  .rc-table-container {
    width: 100%;
  }

  .rc-table-content table {
    width: 100%;
  }

  .rc-table-thead {
    background-color: #eff1f7;
    font-weight: 600;
    height: 52px;
    padding: 16px 0;
    margin-left: 8px;
    font-size: 14px;
  }

  td,
  th {
    padding: 8px 12px;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class CompanySelectionResultTableComp extends BaseComponent {
  constructor(props) {
    super(props);
  }

  get companies() {
    return this.props.companies;
  }

  get homeAddressTypeId() {
    const addressTypeId = this.props.addressTypes.filter(t => t.name === 'home')[0]?.id;
    return addressTypeId;
  }

  getAddressValues(company, propertyName) {
    const homeAddress = company?.addresses?.filter(a => a?.typeId == this.homeAddressTypeId)[0];
    let value = '';
    switch (propertyName) {
      case 'country':
        value = homeAddress?.country?.name ?? '';
        break;
      default:
        value = homeAddress?.[propertyName] ?? '';
    }
    return value;
  }

  getData = company => {
    const name =
      company['company_type'] == 'company'
        ? `${company['name'] || ''}`
        : `${company[property] || ''} ${company['surname'] + ''  ? company['name'] + ' ' + company['surname'] : ''}`;
    const addressLine1 = this.getAddressValues(company, 'addressLine1');
    const city = this.getAddressValues(company, 'city');
    const country = this.getAddressValues(company, 'country');
    const customernumber = company?.['customernumber'];

    return {
      name,
      addressLine1,
      city,
      country,
      customernumber,
    };
  };

  getColumns = reset => {
    let columns = [
      { title: this.lblStr('company.property.name'), dataIndex: 'name', key: 'name', align: 'left' },
      { title: this.lblStr('company.property.addressLine1'), dataIndex: 'addressLine1', key: 'addressLine1', align: 'left' },
      { title: this.lblStr('company.property.city'), dataIndex: 'city', key: 'city', align: 'left' },
      { title: this.lblStr('company.details.country'), dataIndex: 'country', key: 'country', align: 'left' },
      {
        title: this.lblStr('company.property.customernumber'),
        dataIndex: 'customernumber',
        key: 'customernumber',
        align: 'left',
      },
    ];
    if (this.props.selected) {
      columns.push({
        title: this.lblStr('reset'),
        dataIndex: 'reset',
        key: 'reset',
        align: 'right',
        render(value, row, index) {
          return (
            <ButtonComponent style={'ButtonSoftDelete'} onClick={reset}>
              <CircleTimes />
            </ButtonComponent>
          );
        },
      });
    }
    return columns;
  };

  render() {
    const columns = this.getColumns(this.props.reset);
    const data = this.companies?.map(company => {
      return this.getData(company);
    });
    return (
      <Container>
        <CustomTable
          columns={columns}
          data={data}
          scroll={{ x: window.innerWidth < 975 ? 975 : false }}
          emptyText={this.lbl('vehicles.overview.column.no_invoice_found')}
          onRow={(record, index) => {
            return {
              onClick: () => {
                this.props.onCompanySelect(this.companies[index]);
              },

              company: this.companies[index],
            };
          }}
        />
      </Container>
    );
  }
}

CompanySelectionResultTableComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onItemClick: PropTypes.func,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    addressTypes: selectAddressTypes(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanySelectionResultTable = compose(withConnect, withRouter, injectIntl)(CompanySelectionResultTableComp);
